export {
  getDataFromResponse,
  pathologyReportColumns,
  pathologyReportWithResultsColumns,
  getDataPathologyTestResultFromResponse,
} from './columns';
export { initialSearch, searchFields } from './config';
